module.exports = __webpack_public_path__ + "static/media/fuel-system-cleaning-red.7e077e06.svg";